import React from 'react'
import MobileFilterCategories from './MobileFilters/MobileFilterCategories'
import MobileFiltersPrice from './MobileFilters/MobileFiltersPrice'
import MobileFiltersGender from './MobileFilters/MobileFiltersGender'
import MobileFilterBrands from './MobileFilters/MobileFilterBrands'
import MobileFiltersOccasion from './MobileFilters/MobileFiltersOccasion'
import MobileFiltersDiscount from './MobileFilters/MobileFiltersDiscount'
import MobileFilterColors from './MobileFilters/MobileFilterColors'
import MobileFiltersSize from './MobileFilters/MobileFiltersSize'
import MobileFiltersTags from './MobileFilters/MobileFiltersTags'
import MobileFilterRatings from './MobileFilters/MobileFilterRatings'
import MobileFiltersSort from './MobileFilters/MobileFiltersSort'

const MobileFilters = () => {
	return (
		<div>
			<div class='d-flex align-items-start p-1'>
				<div className='col-4 '>
					<div className='categories-list'>
						<div class='nav flex-column nav-pills fiters-width ' id='v-pills-tab' role='tablist' aria-orientation='vertical'>
							<button
								class='nav-link active border-bottom p-3 text-start mb-2'
								id='v-pills-sort-tab'
								data-bs-toggle='pill'
								data-bs-target='#v-pills-sort'
								type='button'
								role='tab'
								aria-controls='v-pills-sort'
								aria-selected='true'
							>
								Sort By
							</button>
							<button
								class='nav-link  border-bottom p-3 text-start mb-2'
								id='v-pills-gender-tab'
								data-bs-toggle='pill'
								data-bs-target='#v-pills-gender'
								type='button'
								role='tab'
								aria-controls='v-pills-gender'
								aria-selected='true'
							>
								Gender
							</button>
							<button
								class='nav-link border-bottom p-3 text-start mb-2'
								id='v-pills-category-tab'
								data-bs-toggle='pill'
								data-bs-target='#v-pills-category'
								type='button'
								role='tab'
								aria-controls='v-pills-category'
								aria-selected='false'
							>
								Category
							</button>
							<button
								class='nav-link border-bottom p-3 text-start mb-2'
								id='v-pills-price-tab'
								data-bs-toggle='pill'
								data-bs-target='#v-pills-price'
								type='button'
								role='tab'
								aria-controls='v-pills-price'
								aria-selected='false'
							>
								Price
							</button>
							<button
								class='nav-link border-bottom p-3 text-start mb-2'
								id='v-pills-brands-tab'
								data-bs-toggle='pill'
								data-bs-target='#v-pills-brands'
								type='button'
								role='tab'
								aria-controls='v-pills-brands'
								aria-selected='false'
							>
								Brands
							</button>
							<button
								class='nav-link border-bottom p-3 text-start mb-2'
								id='v-pills-occasion-tab'
								data-bs-toggle='pill'
								data-bs-target='#v-pills-occasion'
								type='button'
								role='tab'
								aria-controls='v-pills-occasion'
								aria-selected='false'
							>
								Occasion
							</button>
							<button
								class='nav-link border-bottom p-3 text-start mb-2'
								id='v-pills-discounts-tab'
								data-bs-toggle='pill'
								data-bs-target='#v-pills-discounts'
								type='button'
								role='tab'
								aria-controls='v-pills-discounts'
								aria-selected='false'
							>
								Discount
							</button>
							<button
								class='nav-link border-bottom p-3 text-start mb-2'
								id='v-pills-colors-tab'
								data-bs-toggle='pill'
								data-bs-target='#v-pills-colors'
								type='button'
								role='tab'
								aria-controls='v-pills-colors'
								aria-selected='false'
							>
								Colors
							</button>
							<button
								class='nav-link border-bottom p-3 text-start mb-2'
								id='v-pills-size-tab'
								data-bs-toggle='pill'
								data-bs-target='#v-pills-size'
								type='button'
								role='tab'
								aria-controls='v-pills-size'
								aria-selected='false'
							>
								Size & Fit
							</button>
							<button
								class='nav-link border-bottom p-3 text-start mb-2'
								id='v-pills-tags-tab'
								data-bs-toggle='pill'
								data-bs-target='#v-pills-tags'
								type='button'
								role='tab'
								aria-controls='v-pills-tags'
								aria-selected='false'
							>
								Tags
							</button>
							<button
								class='nav-link border-bottom p-3 text-start mb-0'
								id='v-pills-ratings-tab'
								data-bs-toggle='pill'
								data-bs-target='#v-pills-ratings'
								type='button'
								role='tab'
								aria-controls='v-pills-ratings'
								aria-selected='false'
							>
								Rating
							</button>
						</div>
					</div>
				</div>
				<div className='col-8'>
					<div class='tab-content mt-4' id='v-pills-tabContent'>
						<div class='tab-pane fade show active' id='v-pills-sort' role='tabpanel' aria-labelledby='v-pills-sort-tab'>
							<MobileFiltersSort />
						</div>
						<div class='tab-pane fade' id='v-pills-gender' role='tabpanel' aria-labelledby='v-pills-gender-tab'>
							<MobileFiltersGender />
						</div>
						<div class='tab-pane fade' id='v-pills-category' role='tabpanel' aria-labelledby='v-pills-category-tab'>
							<MobileFilterCategories />
						</div>
						<div class='tab-pane fade' id='v-pills-price' role='tabpanel' aria-labelledby='v-pills-price-tab'>
							<MobileFiltersPrice />
						</div>
						<div class='tab-pane fade' id='v-pills-brands' role='tabpanel' aria-labelledby='v-pills-brands-tab'>
							<MobileFilterBrands />
						</div>
						<div class='tab-pane fade' id='v-pills-occasion' role='tabpanel' aria-labelledby='v-pills-occasion-tab'>
							<MobileFiltersOccasion />
						</div>
						<div class='tab-pane fade' id='v-pills-discounts' role='tabpanel' aria-labelledby='v-pills-discounts-tab'>
							<MobileFiltersDiscount />
						</div>
						<div class='tab-pane fade' id='v-pills-colors' role='tabpanel' aria-labelledby='v-pills-colors-tab'>
							<MobileFilterColors />
						</div>
						<div class='tab-pane fade' id='v-pills-size' role='tabpanel' aria-labelledby='v-pills-size-tab'>
							<MobileFiltersSize />
						</div>
						<div class='tab-pane fade' id='v-pills-tags' role='tabpanel' aria-labelledby='v-pills-tags-tab'>
							<MobileFiltersTags />
						</div>
						<div class='tab-pane fade' id='v-pills-ratings' role='tabpanel' aria-labelledby='v-pills-ratings-tab'>
							<MobileFilterRatings />
						</div>
					</div>
				</div>
			</div>
		</div>
	)
}

export default MobileFilters
